import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-processing1",
  "use": "icon-processing1-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-processing1\">\n<style type=\"text/css\">\n\t#icon-processing1 .st0{fill:#FFFFFF;}\n</style>\n<path class=\"st0\" d=\"M182.2,166.1v3.1c0,1.2-0.7,3.4-1.9,3.4h-154c-3.7,0-10-6.7-10-10.3v-129c0-1.2,2.3-2.2,3.5-2.2h3.2\n\tc1.2,0,3.5,1,3.5,2.2V160c0,1.2,1,2.2,2.2,2.2H180C181.2,162.2,182.2,164.9,182.2,166.1z M46.2,153.6h26.7c1.2,0,2.2-1,2.2-2.2V62.4\n\tc0-1.2-1-2.2-2.2-2.2H46.2c-1.2,0-2.2,1-2.2,2.2v88.9C44,152.6,45,153.6,46.2,153.6z M88.4,153.6h26.7c1.2,0,2.2-1,2.2-2.2l0-106.7\n\tc0-1.2-1-2.2-2.2-2.2H88.4c-1.2,0-2.2,1-2.2,2.2v106.7C86.2,152.6,87.2,153.6,88.4,153.6z M130.7,153.6h26.7c1.2,0,2.2-1,2.2-2.2\n\tV95.8c0-1.2-1-2.2-2.2-2.2h-26.7c-1.2,0-2.2,1-2.2,2.2v55.6C128.4,152.6,129.4,153.6,130.7,153.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/processing1.svg
// module id = B6YD
// module chunks = 148